<template>
  <div class="d-flex">
    <div class="ms-2" style="white-space:nowrap" v-for="tab, idx in mainStore.slideover_history">
      <span class="breadcrump" :class="{ 'active': idx == mainStore.slideover_index }" @click="mainStore.slideover_index = idx">
        {{ tab.name }}
      </span>
      <span v-if="idx != mainStore.slideover_history.length-1">&gt;</span>
    </div>
  </div>
</template>

<script setup>
import {computed, defineEmits, onMounted, onUnmounted, ref, watch, nextTick} from 'vue'

import { useMainStore } from '@/stores/main'
let mainStore = useMainStore()

</script>

<style scoped>
.breadcrump {
  cursor: pointer;
}

.breadcrump:hover {
  color: rgb(205, 213, 224);
}

.breadcrump.active {
  color: white;
}
</style>
